module.exports = __webpack_public_path__ + "img/banner.03340f65.png";